import React from "react";
import { GripVertical, Check } from "lucide-react";
import { Button } from "@/components/ui/button";
import { money, paymentClass, formatDate } from "@/lib/utils-app";
import WhatsAppButton from "@/components/WhatsAppButton";

/**
 * Draggable Kanban card. Pure — receives the OS + drag handlers; column decides what it renders.
 */
export default function OSCard({ os, columnKey, isDragging, onDragStart, onDragEnd, onClick, onAccept }) {
  const whatsAppMsg = `Olá ${os.customer_name}, tudo bem? Aqui é da GTec sobre a OS ${os.os_code} (${os.device_brand} ${os.device_model}).`;
  const showAuthorized = columnKey === "Aguardando Autorização" && os.authorized;
  const showPaymentPill = columnKey === "Serviço Concluído";
  const showAcceptButton = columnKey === "Solicitação de Reparo";

  return (
    <div
      draggable
      onDragStart={(e) => onDragStart(e, os)}
      onDragEnd={onDragEnd}
      onClick={() => { if (!isDragging) onClick(os.os_code); }}
      className={`group bg-white rounded-lg border transition-all p-3 cursor-grab active:cursor-grabbing ${isDragging ? "opacity-40 border-neutral-900" : "border-neutral-200 hover:border-neutral-900 hover:-translate-y-0.5 hover:shadow-md"}`}
      data-testid={`board-card-${os.os_code}`}
    >
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-1.5">
          <GripVertical size={12} className="text-neutral-300 group-hover:text-neutral-500" />
          <div className="font-mono text-sm font-bold">{os.os_code}</div>
        </div>
        <div className="font-mono text-xs text-neutral-600">{money(os.total)}</div>
      </div>
      <div className="text-sm text-neutral-800 mt-1 truncate">{os.customer_name} {os.customer_surname}</div>
      <div className="text-xs text-neutral-500 truncate">{os.device_brand} {os.device_model}</div>

      <div className="mt-2 flex items-center justify-between gap-2 flex-wrap">
        <div className="text-[10px] text-neutral-400">{formatDate(os.updated_at || os.created_at)}</div>
        <WhatsAppButton
          phone={os.customer_phone}
          message={whatsAppMsg}
          testid={`board-wa-${os.os_code}`}
          size="xs"
        />
      </div>

      {showAuthorized && (
        <div className="mt-2 text-[10px] bg-green-50 text-green-700 border border-green-200 rounded px-2 py-1 inline-block">✓ Autorizado</div>
      )}
      {showPaymentPill && (
        <div className="mt-2"><span className={paymentClass(os.payment_status)}>● {os.payment_status}</span></div>
      )}
      {showAcceptButton && (
        <Button
          size="sm"
          onClick={(e) => onAccept(os.os_code, e)}
          data-testid={`board-accept-${os.os_code}`}
          className="mt-3 w-full h-8 bg-neutral-900 hover:bg-neutral-800 text-white text-xs font-semibold"
        >
          <Check size={13} className="mr-1"/> Aceitar solicitação
        </Button>
      )}
    </div>
  );
}
